export const SERVER_ACTION = {
  START: 'start',
  STOP: 'stop',
  REBOOT: 'reboot',
};
